import i18n from 'i18next';

const translateArray = (item) => {
  return i18n.t(item);
};

export { translateArray };
